/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type SbRespAppliedFilters_itemSearch$ref = any;
type SbSharedRefineMenuDisplayPrefsSelect_itemSearch$ref = any;
type SbSharedRefineMenuFilters_itemSearch$ref = any;
export type VerticalType = "art" | "fashion" | "furniture" | "jewelry" | "%future added value";
export type SbRespRefineMenu_itemSearch$ref = any;
export type SbRespRefineMenu_itemSearch = {
    readonly topCategoryL1: VerticalType | null;
    readonly " $fragmentRefs": SbRespAppliedFilters_itemSearch$ref & SbSharedRefineMenuFilters_itemSearch$ref & SbSharedRefineMenuDisplayPrefsSelect_itemSearch$ref;
    readonly " $refType": SbRespRefineMenu_itemSearch$ref;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbRespRefineMenu_itemSearch",
  "type": "ItemSearchQueryConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "topCategoryL1",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespAppliedFilters_itemSearch",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilters_itemSearch",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuDisplayPrefsSelect_itemSearch",
      "args": null
    }
  ]
};
(node as any).hash = '09b670ab8ef3af2b6168c20764b9fdd7';
export default node;
